import React, { createContext, useState } from "react";

interface ActiveOrDisableActionContextType {
  user: any;
  setUser: (user: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

export const ActiveOrDisableActionContext = createContext<ActiveOrDisableActionContextType>({
  user: null,
  setUser: () => {},
  showModal: false,
  setShowModal: () => {},
});

interface ActiveOrDisableActionProviderProps {
  children: React.ReactNode;
}

export const ActiveOrDisableActionProvider: React.FC<ActiveOrDisableActionProviderProps> = ({
  children,
}) => {
  const [user, setUser] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);

  const value = {
    user,
    setUser,
    showModal,
    setShowModal
  };
  return (
    <ActiveOrDisableActionContext.Provider value={value}>
      {children}
    </ActiveOrDisableActionContext.Provider>
  );
};
